import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const FcFlows = React.lazy(() => import('./index'));
const FcFlowTable = React.lazy(() => import('./fcFlowTable'));
const FcFlow = React.lazy(() => import('./fcFlow'));
const FcFlowDetail = React.lazy(() => import('./fcFlowDetail'));
const AddNewFcFlow = React.lazy(() => import('./addNewFcFlow'));
const EditFcFlow = React.lazy(() => import('./editFcFlow'));

export const useFcFlowRoutes = () => {
    return (
        <React.Fragment>
            <Route path="fcFlow" element={<Suspense fallback={<div>منتظر باشید...</div>}><FcFlows isCumulative={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FcFlowTable isCumulative={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewFcFlow isCumulative={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><FcFlow isCumulative={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FcFlowDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditFcFlow /></Suspense> } />
                </Route>
            </Route>
            <Route path="cumulativeFcFlow" element={<Suspense fallback={<div>منتظر باشید...</div>}><FcFlows isCumulative={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FcFlowTable isCumulative={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewFcFlow isCumulative={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><FcFlow isCumulative={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FcFlowDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditFcFlow /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}